import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["shouldScaleBackground"],
      _excluded2 = ["className", "children"],
      _excluded3 = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import styles from './styles.module.scss'; // Creates a drawer container for the mobile UX
// inserts menu in portal - in new DOM location

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const Drawer = _ref => {
  let {
    shouldScaleBackground = true
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(DrawerPrimitive.Root, _objectSpread({
    shouldScaleBackground: shouldScaleBackground
  }, props));
};

Drawer.displayName = 'Drawer';
const DrawerContent = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className,
    children
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsxs(DrawerPortal, {
    children: [/*#__PURE__*/_jsx(DrawerOverlay, {}), /*#__PURE__*/_jsxs(DrawerPrimitive.Content, _objectSpread(_objectSpread({
      ref: ref,
      className: clsx(styles.drawerContent, className),
      "aria-describedby": undefined
    }, props), {}, {
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.drawerHandle
      }), /*#__PURE__*/_jsx(DrawerTitle, {}), children]
    }))]
  });
});
DrawerContent.displayName = 'DrawerContent';
const DrawerOverlay = /*#__PURE__*/React.forwardRef((_ref3, ref) => {
  let {
    className
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_jsx(DrawerPrimitive.Overlay, _objectSpread({
    ref: ref,
    className: clsx(styles.drawerOverlay, className)
  }, props));
});
DrawerOverlay.displayName = DrawerPrimitive.Overlay.displayName;
const DrawerPortal = DrawerPrimitive.Portal;
const DrawerClose = DrawerPrimitive.Close;
const DrawerTitle = DrawerPrimitive.Title;
export { Drawer, DrawerPortal, DrawerOverlay, DrawerClose, DrawerContent, DrawerTitle };